import { render } from "./YellowBtn.vue?vue&type=template&id=53409282&scoped=true"
import script from "./YellowBtn.vue?vue&type=script&lang=js"
export * from "./YellowBtn.vue?vue&type=script&lang=js"

import "./YellowBtn.vue?vue&type=style&index=0&id=53409282&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53409282"]])

export default __exports__